import Grid from '../components/grid'
import Carousel from '../components/ui/carousel/carousel'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'
import { IoMdReturnRight } from 'react-icons/io'
import { useInView } from 'react-intersection-observer'
import { SwiperSlide } from 'swiper/react'

const partnersResponsive = {
  '1500': {
    slidesPerView: 6,
    spaceBetween: 34,
  },
  '1280': {
    slidesPerView: 5,
    spaceBetween: 28,
  },
  '768': {
    slidesPerView: 4,
    spaceBetween: 24,
  },
  '480': {
    slidesPerView: 3,
    spaceBetween: 20,
  },
  '0': {
    slidesPerView: 2,
    spaceBetween: 12,
  },
}

export type BenefitsSliderBlockProps = Extract<Page['blocks'][0], { blockType: 'benefits-slider' }>

export default function BenefitsSlider(block: BenefitsSliderBlockProps): ReactElement {
  const { title = 'BENEFITS', items } = block
  const { ref } = useInView({
    threshold: 0.4,
  })

  return (
    <Container>
      <div ref={ref}>
        <Grid className="py-8 md:py-12 lg:py-20">
          <div className="col-span-full md:col-span-4 lg:col-span-8 flex relative justify-start items-center max-w-lg">
            <IoMdReturnRight className="mr-1 text-black" />
            <Text variant="subHeading" className="max-w-md text-left">
              {title}
            </Text>
          </div>
          <div className="w-full h-full col-span-full md:col-span-4"></div>
          <div className="heightFull col-span-full w-full cursor-pointer">
            <Carousel
              breakpoints={partnersResponsive}
              buttonSize="small"
              autoplay={true}
              paginationVariant="hidden"
            >
              {items &&
                items.length >= 4 &&
                items.map((item: any, idx: number) => {
                  return (
                    <SwiperSlide key={`partner-logos-slider--${idx}`}>
                      <div className="max-w-[280px]">
                        <Text variant="heading">{item?.title}</Text>
                        {item?.isDescription && (
                          <Text className="mt-4" variant="body">
                            {item?.description}
                          </Text>
                        )}
                      </div>
                    </SwiperSlide>
                  )
                })}
            </Carousel>
          </div>
        </Grid>
      </div>
    </Container>
  )
}
